import { render } from "./SingleSelectImage.vue?vue&type=template&id=1392d967&scoped=true"
import script from "./SingleSelectImage.vue?vue&type=script&lang=ts"
export * from "./SingleSelectImage.vue?vue&type=script&lang=ts"

import "./SingleSelectImage.vue?vue&type=style&index=0&id=1392d967&lang=less&scoped=true"
import "./SingleSelectImage.vue?vue&type=style&index=1&id=1392d967&lang=less"
script.render = render
script.__scopeId = "data-v-1392d967"

export default script